export default __webpack_public_path__ + "static/media/gallery-image-11.9ff4c5b9.jpg";